import { Instance, types } from 'mobx-state-tree';

const FlagsStore = types.model({
  isRequesting: false,
  isSubmitting: false,
});

export interface TFlagsStore extends Instance<typeof FlagsStore> {}
export default FlagsStore;
